import Cookies from 'js-cookie';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Dropdown, Navbar } from 'react-bootstrap';
import {
  CloseIcon,
  DashboardIcon,
  Hamburger,
  LogoutIcon,
  MenuUserIcon,
} from '../../assets/icons';
import { LogoTransparent } from '../../assets/images';
import { useDocContext } from '../../context/DocContext';
import { toast } from 'react-toastify';
import Sidebar from './Sidebar';
const Dashboard_Header = () => {
  const router = useRouter();
  const [menuOpen, setmenuOpen] = useState(false);
  const pathname = router.pathname;
  const { user, setContext, hasNotifications } = useDocContext();

  const Logout = () => {
    Cookies.remove('sessionToken');
    setContext((context) => {
      return { ...context, user: undefined };
    });
    router.push('/');
    toast.success('You have successfully logged out');
  };
  return (
    <header className='dashboardHeader'>
      {menuOpen && (
        <div className='menuBarDashboard'>
          <div
            className='tw-flex tw-py-4'
            style={{ borderBottom: '1px solid #ebebeb' }}
          >
            <button
              className='dashboardMenuBtn tw-mb-1 tw-mr-1 tw-bg-transparent'
              onClick={() => setmenuOpen(!menuOpen)}
            >
              {<CloseIcon />}
            </button>
            <Link href='/' passHref>
              <Navbar.Brand>
                <Image
                  src={LogoTransparent}
                  alt='mobile-logo'
                  width={133}
                  height={30}
                />
              </Navbar.Brand>
            </Link>
          </div>
          <div className=' tw-flex tw-flex-col tw-justify-between tw-h-full'>
            <Sidebar setmenuOpen={setmenuOpen} />
          </div>
        </div>
      )}
      <div className='tw-flex'>
        <button
          className='dashboardMenuBtn tw-mb-1 tw-mr-1'
          onClick={() => setmenuOpen(!menuOpen)}
        >
          {<Hamburger />}
        </button>
        <Link href='/' passHref>
          <Navbar.Brand>
            <Image
              src={LogoTransparent}
              alt='mobile-logo'
              width={133}
              height={30}
            />
          </Navbar.Brand>
        </Link>
      </div>
      <div className='header-right-side'>
        <button
          className='btnNewDiagnosis'
          onClick={() => router.push('/services')}
        >
          <span>+</span> New Diagnosis
        </button>
        <div className='rightMenu'>
          <Dropdown>
            <Dropdown.Toggle variant='success' id='dropdown-basic'>
              <MenuUserIcon /> {user?.first_name} {user?.last_name?.[0]}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href='/dashboard'
                className=' d-flex align-items-center'
                style={{ fontSize: '12px', fontWeight: 500 }}
              >
                <DashboardIcon />{' '}
                <span style={{ marginLeft: '.5rem' }}>Dashboard</span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={Logout}
                className=' d-flex align-items-center'
                style={{ fontSize: '12px', fontWeight: 500 }}
              >
                <LogoutIcon />{' '}
                <span style={{ marginLeft: '.5rem' }}>Logout</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};
const navLinks = [
  { name: 'Home', address: '/dashboard' },
  {
    name: 'Diagnostic History',
    address: '/dashboard/history',
  },
  {
    name: 'Track Progress',
    address: '/dashboard/sexual-diseases',
  },
  {
    name: 'Prescription Refills',
    address: '/dashboard/refills',
  },
  {
    name: 'Account',
    address: '/dashboard/user',
  },
];
export default Dashboard_Header;
const ArrowLeft = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.6'>
      <path
        d='M14.25 9H3.75M3.75 9L9 14.25M3.75 9L9 3.75'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
